<template>
  <b-modal id="modal-sale-register"
           content-class="md_inner_modal"
           header-class="popup_header1"
           :visible="visible"
           @hidden="onCancel();"
           hide-footer centered>
    <template #modal-title>
      <div class="align-horizontal">
        <span style="font-size: 18px; font-family: 'KoreanGD15R';">{{$t('more.sale_registration')}}</span>
        <b-button class="reg_regist_btn reg_regist_btn_text" @click="onRequestRegist" style="font-size: 14px; font-family: 'KoreanGD14R';width: 75px;height: 32px;background-color: #F9E000;margin-left: 10px; color:black;">
          {{$t('more.reg_regist')}}
        </b-button>
      </div>
    </template>
    <template #modal-header-close>
      <img class="dlg_close_btn" src="../../../assets/image/ic_close2.png" style="width: 1.2rem; height: 1.2rem; margin-top: 5px;">
    </template>
    <div class="align-horizontal" style="justify-content: space-around">
      <b-button
        @click="checkTemporarySave('O')"
        class="md_btn align-vertical v_center" variant="light" style="background-color: white">
        <img src="../../../assets/image/ic_new_open.png" style="margin-left: 5px;">
        <span class="margin-top-15" style="font-size: 18px; font-family: 'KoreanGD14R';">{{$t('map.new_open_site')}}</span>
      </b-button>
      <b-button
        @click="checkTemporarySave('G')"
        class="md_btn align-vertical v_center" variant="light" style="background-color: white">
        <img src="../../../assets/image/ic_general_sale.png">
        <span class="margin-top-15" style="font-size: 18px; font-family: 'KoreanGD14R';">{{$t('map.general_site')}}</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import Utils from '../../../config/utils'
const utils = require('util');
export default {
  name: "SiteRegisterPopup",
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      self: this,
      u: Utils,
      ut: utils,
    }
  },
  methods:{
    onShow() {

    },
    onCancel()  {
      this.$emit('update:visible', false);
    },
    onRequestRegist () {
      //TODO: 매물등록에서 등록요청을 눌렀을 때의 기능실현
      window.open('http://pf.kakao.com/_xgctis', '_blank');
    },

    checkTemporarySave(saleType) {
      this.$bvModal.hide('modal-sale-register');
      Utils.requestGet(
        this.$c.API.Site.checkTemporarySave,
        {site_type: saleType},
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          if (result.data.count > 0) {
            Utils.showConfirm(this, this.$t('more.load_temporary_save')).then(value => {
              if(value) {
                Utils.requestGet(
                  this.$c.API.Site.getSiteDetail,
                  {
                    site_idx: result.data.site_idx,
                    save: 1
                  }).then(result => {
                  if (result.code == this.$c.API_RES_CODE.SUCCESS) {

                    if (saleType == 'O') {
                      this.$router.push({name: 'RegSite1', params: {
                          "type": 'New',
                          "common": result.data.common,
                          "ho_list": result.data.ho_list,
                          "dong_list": result.data.dong_list,
                          "contact_list": result.data.contact_list,
                          "room_list": result.data.room_list
                        }});
                    } else {
                      this.$router.push({name: 'RegSite1',params:{
                          "type": 'General',
                          "common": result.data.common,
                          "contact_list": result.data.contact_list,
                          "room_list": result.data.room_list
                        }});
                    }
                  }
                });
              } else {
                Utils.requestPost(this.$c.API.Site.removeTemporarySave, {
                  site_type: saleType
                }).then(async () => {
                  await this.$perf.setInt(this.$c.PREF_PARAMS.TEMP_STEP, 0);
                  if (saleType == 'O') {
                    await this.$router.push({name: 'RegSite1', params: {type:'New'}});
                  } else {
                    await this.$router.push({name: 'RegSite1', params: {type:'General'}});
                  }
                });
              }
            });
          } else {
            if (saleType == 'O') {
              this.$router.push({name: 'RegSite1', params: {type:'New'}});
            } else {
              this.$router.push({name: 'RegSite1', params: {type:'General'}});
            }
          }
        } else {
          Utils.toast(result.msg);
        }
      });
    }

  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/Modal.scss";


</style>



// WEBPACK FOOTER //
// src/components/controls/popup/SiteRegisterPopup.vue